module.exports = __webpack_public_path__ + "img/iconA.1b21ef26.png";